import { AxiosResponse } from 'axios'

import ClientSDK from '../../../App/ClientSDK'

import { IApiLastMinute, ILastMinute } from './ILastMinute'
import Transformer from './Transformer'

class Client {
    static getLastMinutes = (): Promise<ILastMinute[]> =>
        ClientSDK.instance()
            .get('calendar/last-minutes', { is_available_only: false })
            .then((response: AxiosResponse): ILastMinute[] => {
                return response.data.data.map((data: IApiLastMinute) =>
                    Transformer.transform(data)
                )
            })
    static deleteLastMinute = (lastMinute: ILastMinute): Promise<ILastMinute> =>
        ClientSDK.instance()
            .delete('calendar/last-minutes/' + lastMinute.id)
            .then(
                (response: AxiosResponse): ILastMinute => {
                    return lastMinute
                }
            )

    static deleteLastMinutePermanent = (
        lastMinute: ILastMinute
    ): Promise<ILastMinute> =>
        ClientSDK.instance()
            .delete('calendar/last-minutes/' + lastMinute.id)
            .then(
                (response: AxiosResponse): ILastMinute => {
                    return lastMinute
                }
            )
    static restoreLastMinute = (
        lastMinute: ILastMinute
    ): Promise<ILastMinute> =>
        ClientSDK.instance()
            .patch('calendar/last-minutes/' + lastMinute.id, {
                operation: 'restore',
            })
            .then(
                (response: AxiosResponse): ILastMinute => {
                    return lastMinute
                }
            )
}

export default Client
